var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"base"}},[_c('base-card',[_c('logo'),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.stepComponent,{tag:"component",staticClass:"content"})],1),_vm._v(" "),_c('come-back')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70969926","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignUp/Index.vue
// module id = null
// module chunks = 